<template>
<div>
<div class="header">
      <vs-button
        class="back-btn"
        size="large"
        icon="arrow_back"
        @click="$router.push('tool')"
      />
  <h1>MEDAQUA</h1>
  <vs-divider></vs-divider>
</div>
  <p style="padding-left: 10%;padding-right: 10%;padding-top: 3%;">
    The project Examining the Opportunities for Multiuse Activities in the
    Mediterranean Sea: Aquaculture and Renewable Energies (MEDAQUA) pursues
    to implement a pilot application to address aquaculture and renewable
    energy exploitation opportunities in the Mediterranean Sea and to identify
    opportunities for multiple use of the space through the co-location of these
    activities. The methodological approach developed is based on Copernicus marine
    and climate change data services and has been widely implemented and validated
    at the global, regional and local scale.
    </p>
    <br />
    <h3 style="text-align: left; padding-left: 10%;padding-right: 10%;">
      WEBINAR
    </h3>
    <br />
    <p style="padding-left: 10%;padding-right: 10%;">
      We invite you to take a look at the MEDAQUA webinar, which consists of five videos
      aimed at improving the exchange and transfer of knowledge and technology to stakeholders,
      practitioners and authorities.
    </p>
    <div class="video">
    <h4>
      WEBINAR: Part 1
    </h4>
    <p class="webinar">
      Tools to analyse the existing uses and potential opportunities: Introduction
    </p>
      <iframe
        src="https://player.vimeo.com/video/865534727"
        width="640"
        height="360"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      >
      </iframe>
    </div>
    <div class="video">
    <h4>
      WEBINAR: Part 2
    </h4>
    <p class="webinar">
      Tools to analyse the existing uses and potential opportunities: Methodology
    </p>
      <iframe
        src="https://player.vimeo.com/video/865535581"
        width="640"
        height="360"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      >
      </iframe>
    </div>
    <div class="video">
    <h4>
      WEBINAR: Part 3
    </h4>
    <p class="webinar">
      Tools to analyse the existing uses and potential opportunities: Applications
    </p>
      <iframe
        src="https://player.vimeo.com/video/865536166"
        width="640"
        height="360"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      >
      </iframe>
    </div>
    <div class="video">
    <h4>
      WEBINAR: Part 4
    </h4>
    <p class="webinar">
      Tools to analyse the future uses and opportunities: A case study applied to the Spanish coast
    </p>
      <iframe
        src="https://player.vimeo.com/video/865536437"
        width="640"
        height="360"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      >
      </iframe>
    </div>
    <div class="video">
      <h4>
        WEBINAR: Part 5
      </h4>
      <p class="webinar">
        Tools for the multiuse of the maritime space: A case study applied to the aquaculture and wind energy
      </p>
      <iframe
        src="https://player.vimeo.com/video/865536897"
        width="640"
        height="360"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      >
      </iframe>
    </div>
    <div class="info-button">
        <vs-button
          href="https://www.copernicus-user-uptake.eu/user-uptake/details/examining-the-opportunities-for-multiuse-activities-in-the-mediterranean-sea-aquaculture-and-renewable-energies-medaqua-333"
          class="accent"
          type="filled"
          target
          line-position="top"
          >+ Info</vs-button
        >
    </div>
    <div class="logos-item">
      <vs-divider>with the support of</vs-divider>
      <a
        href="https://www.copernicus.eu"
        title="Copernicus"
        target="blank"
      >
        <img src="@/assets/logos/copernicus.png" style="max-width: 20%;"/>
      </a>
      <p style="padding-left: 10%;padding-right: 10%;padding-bottom: 3%;">
        This platform is partially supported by the European Union’s Caroline
        Herschel Framework Partnership Agreement on Copernicus User Uptake under
        grant agreement No FPA 275/G/GRO/COPE/17/10042, project FPCUP (Framework
        Partnership Agreement on Copernicus User Uptake), Action 2020-2-4 "Examining
        the opportunities for multiuse activities in the Mediterranean Sea: Aquaculture
        and renewable energies (MEDAQUA)”.
      </p>
    </div>
    </div>
</template>
<script>
export default {
  name: "MedaquaWebinarView",
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.modal-about >>> .sweet-modal {
  max-width: 1100px !important;
}
.sweet-modal-overlay {
  background: rgba(0, 0, 0, 0.1);
}

.project-grid {
  display: grid;
  grid-gap: 1rem;
  max-height: 50vh;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 0.8fr 0.2fr;
}
.renaqua-grid {
  display: grid;
  grid-gap: 1rem;
  max-height: 50vh;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
}

.thumb-item {
  grid-row: 1 / 2;
  grid-column: 1 / 2;
}
.description-item {
  grid-column: 2 / 2;
  grid-row: 1 / 2;
}
.logos-item {
  grid-row: 2 / 2;
  grid-column: span 2;
}

.logos-item img {
  margin: 10px;
}

.logo-ih {
  margin-top: 2rem;
  max-width: 225px;
}

.thumbs {
  max-height: 11rem;
}

.info-button {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
.video {
  margin: 3rem;
}
.webinar {
  text-align: center;
}
.header {
  padding: 15px;
  text-align: center;
  background: white;
  color: #1abc9c;
  font-size: 30px;
}
.back-btn {
	font-size: 16px; /* Cambiar el tamaño de la tipografia */
	text-transform: uppercase; /* Texto en mayusculas */
	font-weight: bold; /* Fuente en negrita o bold */
	color: #ffffff; /* Color del texto */
	border-radius: 50%; /* Borde del boton */
	background-color: #1abc9c; /* Color de fondo */
	position: fixed;
	top: 30px;
	left: 30px;
	box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
	z-index: 99;
}
</style>
